import React from 'react';
import AmbientVideo from "../../sharedComponents/ambientVideo/Video"
import * as classes from './HeroText.module.scss'
import OutputHTML from '../../helpers/OutputHTML';

const heroImages = require.context('./images', true, /.*\.(gif|png|jpe?g|svg)$/i);

function HeroText({content, cdnBase}) {
    return (
        <div className={`${classes.HeroText}`}>
            <div style={{display:"block", width:"100%", height:"100%", overflow:"hidden", position:"relative"}}>
                <AmbientVideo posterSrcContext={heroImages} posterSrc={content.background.poster} src={content.background.video} cdnBase={cdnBase}></AmbientVideo>
                <div className={`${classes.HeroText__titleContainer}`}>
                    <h1 className={`${classes.HeroText__titleContainer__line1}`} dangerouslySetInnerHTML={ OutputHTML( content.titleLine1) }></h1>
                    <h1 className={`${classes.HeroText__titleContainer__line2}`} dangerouslySetInnerHTML={ OutputHTML( content.titleLine2) }></h1>
                </div>
                <div className={`${classes.HeroText__copyContainer}`}>
                    <div>{content.text}</div>
                </div>
                
            </div>
            
        </div>
    );
}

export default HeroText;